(function () {
  'use strict';

  var form = document.getElementById('return-form');
  if (!form) return;

  var messageBox = form.querySelector('.return-form__message');
  var submitButton = form.querySelector('.return-form__submit');
  var endpoint = form.getAttribute('data-endpoint');

  function showMessage(text, type) {
    messageBox.textContent = text;
    messageBox.hidden = false;
    messageBox.classList.remove('return-form__message--success', 'return-form__message--error');
    messageBox.classList.add('return-form__message--' + type);
  }

  function setLoading(isLoading) {
    submitButton.disabled = isLoading;
    submitButton.classList.toggle('return-form__submit--loading', isLoading);
  }

  function clearFieldErrors() {
    form.querySelectorAll('.field--error').forEach(function (field) {
      field.classList.remove('field--error');
    });
  }

  function showFieldErrors(errors) {
    Object.keys(errors || {}).forEach(function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      if (input) {
        input.closest('.field').classList.add('field--error');
      }
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (!endpoint) {
      showMessage('Formulář není správně nastavený (chybí adresa serveru).', 'error');
      return;
    }

    clearFieldErrors();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var payload = {
      order_number: form.order_number.value.trim(),
      customer_email: form.customer_email.value.trim(),
      website: form.website.value
    };

    setLoading(true);
    messageBox.hidden = true;

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (result.ok && result.data.success) {
          showMessage(result.data.message, 'success');
          form.reset();
        } else {
          showMessage(
            result.data.message || 'Odeslání se nezdařilo. Zkuste to prosím znovu.',
            'error'
          );
          if (result.data.errors) {
            showFieldErrors(result.data.errors);
          }
        }
      })
      .catch(function () {
        showMessage('Odeslání se nezdařilo. Zkontrolujte prosím připojení a zkuste to znovu.', 'error');
      })
      .finally(function () {
        setLoading(false);
      });
  });
})();
